<div class="agenx-radio__container">
  <label [ngClass]="labelClasses">
    <input [id]="idInput" class="agenx-radio__radio" [value]="value" [checked]="checked" [formControl]="control"
      type="radio" [name]="nameInput" (click)="sendValue()">
    {{ label }}
  </label>
</div>
